import { get, writable } from 'svelte/store';
import '../../app.logic';
import '../../services/company.service';
import { CompanyInvoiceService } from '../../services/companyinvoice.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export function resetSearchFilter() {
    filter.set({ criteria: { dataFrom: null, dataTo: null }, params: null, sorting: "" });
}
export async function clearSearch() {
    resetSearchFilter();
    search();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await CompanyInvoiceService.getCompanyInvoicesEmails(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export async function exportInvoicePdf(invoiceid) {
    CompanyInvoiceService.downloadInvoicePDF(invoiceid);
}
export async function sendEmail(invoiceoid, companyid) {
    if (invoiceoid != null) {
        await CompanyInvoiceService.sendCompanyInvoiceEmail(invoiceoid).toPromise();
        await load();
    }
}
